module.exports = __webpack_public_path__ + "static/media/brain-chair.3eb8a312.gif";